import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appLettersOnly]'
})
export class LettersOnlyDirective {

    constructor(private el: ElementRef,
        private renderer: Renderer2) { }

    private allowedKeys = [
        'Backspace', 'Tab', 'Delete',
        'ArrowLeft', 'ArrowRight', 'Home', 'End'
    ];

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {

        if (this.allowedKeys.indexOf(event.key) !== -1) {
            return;
        }

        if ((event.ctrlKey || event.metaKey) &&
            ['a', 'c', 'v', 'x'].indexOf(event.key.toLowerCase()) !== -1) {
            return;
        }

        if (!/^[a-zA-Z ]$/.test(event.key)) {
            event.preventDefault();
        }
    }

    @HostListener('input')
    onInput() {
        var input = this.el.nativeElement as HTMLInputElement;
        var raw = input.value || '';
        var sanitized = raw.replace(/[^a-zA-Z ]/g, '');

        if (raw !== sanitized) {
            this.renderer.setProperty(input, 'value', sanitized);
            input.dispatchEvent(new Event('input'));
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        event.preventDefault();

        var clipboardData = event.clipboardData || (window as any).clipboardData;
        var pasted = clipboardData && clipboardData.getData
            ? clipboardData.getData('text')
            : '';

        var sanitized = pasted.replace(/[^a-zA-Z ]/g, '');

        var input = this.el.nativeElement as HTMLInputElement;
        this.renderer.setProperty(input, 'value', sanitized);
        input.dispatchEvent(new Event('input'));
    }
}
